//lodash
import pick from 'lodash/pick';
import memoize from 'lodash/memoize';

//helpers
import {createGhostElement} from 'utils/dom-utils';

// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Fonts
const fontCssProps = [
  'font',
  'fontFamily',
  'fontFeatureSettings',
  'fontKerning',
  'fontLanguageOverride',
  'fontOpticalSizing',
  'fontSize',
  'fontSizeAdjust',
  'fontStretch',
  'fontStyle',
  'fontSynthesis',
  'fontVariant',
  'fontVariantAlternates',
  'fontVariantCaps',
  'fontVariantEastAsian',
  'fontVariantLigatures',
  'fontVariantNumeric',
  'fontVariantPosition',
  'fontVariationSettings',
  'fontWeight',
  'lineHeight'
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Text
const textCssProps = [
  'hangingPunctuation',
  'hyphens',
  'letterSpacing',
  'lineBreak',
  'overflowWrap',
  'tabSize',
  'textAlign',
  'textAlignLast',
  'textIndent',
  'textJustify',
  'textSizeAdjust',
  'textTransform',
  'whiteSpace',
  'wordBreak',
  'wordSpacing'
];

// https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Text_Decoration
const textDecorationCssProps = [
  'letterSpacing',
  'textAlign',
  'textDecoration',
  'textDecorationColor',
  'textDecorationLine',
  'textDecorationStyle',
  'textEmphasis',
  'textEmphasisColor',
  'textEmphasisPosition',
  'textEmphasisStyle',
  'textIndent',
  'textRendering',
  'textShadow',
  'textTransform',
  'whiteSpace',
  'wordSpacing'
];

const widthRelatedCssProps = [
  'border',
  'borderLeft',
  'borderLeftWidth',
  'borderRight',
  'borderRightWidth',
  'borderWidth',
  'padding',
  'paddingLeft',
  'paddingRight'
];

export default class TextWidthMeasurer {
  ghostElement = createGhostElement();

  constructor(referenceStyleOrElement) {
    if (referenceStyleOrElement instanceof Element) {
      referenceStyleOrElement = window.getComputedStyle(referenceStyleOrElement);
    }

    const sizeRelatedStyle = pick(
      referenceStyleOrElement,
      fontCssProps,
      textCssProps,
      textDecorationCssProps,
      widthRelatedCssProps
    );

    Object.assign(this.ghostElement.style, sizeRelatedStyle, {
      whiteSpace: 'pre'
    });

    document.body.appendChild(this.ghostElement);
  }

  destroy = () => {
    document.body.removeChild(this.ghostElement);
  };

  measure = memoize(string => {
    this.ghostElement.textContent = string;
    return this.ghostElement.offsetWidth;
  });
}
